<template>
  <div id="myDiv">
    <vs-breadcrumb v-if="userAccount === 'betagrodemo' || admin == 'betagrodemo'">
      <li>
        <a aria-current="page" style="color: #ffffff" title="Device Management"
          >Setting</a
        ><span style="color: #ffffff" class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">Alert Setting</li>
    </vs-breadcrumb>
    <vs-breadcrumb v-else>
      <li>
        <a aria-current="page" style="color: rgba(0, 0, 0, 0.4)" title="Setting"
          >Setting</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">Alert Setting</li>
    </vs-breadcrumb>
    <vs-card style="border-radius: 20px">
      <div class="mt-2" slot="header">
        <vs-row id="center">
          <h3 class="headerText">Alert Setting</h3>
          <vs-spacer />

          <vs-tooltip text="Create New Alert" position="left">
            <h6>
              <vs-button
                color="success"
                style="border-radius: 20px"
                size="sm"
                icon="add"
                @click="link()"
                type="filled"
                >Add Alert</vs-button
              >
            </h6>
          </vs-tooltip>
        </vs-row>
      </div>

      <ActionList v-if="this.actionList[0]" :actionList="this.actionList" />
    </vs-card>
  </div>
</template>

<script>
import ActionList from "../../dashboard/Alert/ActionListIndoor";
import html2pdf from "html2pdf.js";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
export default {
  name: "IndoorAlertSetting",
  data: () => ({
    userAccount: "",
    actionList: [],
    fields: ["first_name", "last_name", "age"],
    dataExport: [],
    dataBody: [],
    action: "",
    condition: "",
    admin: "",
  }),
  components: {
    ActionList,
  },
  methods: {
    print() {
      console.log(this.actionList);
      var datacondition = "";
      var dataAction = "";
      var dataActive = "";
      this.actionList.forEach((element) => {
        element.con.forEach((data) => {
          Object.keys(data).forEach((key) => {
            this.condition += data[key] + " ";
          });
          // console.log(this.condition)
        });
        element.action.forEach((data) => {
          Object.keys(data).forEach((key) => {
            this.action += data[key] + " ";
          });
          // console.lo;g(this.action)
        });
        console.log(this.action);
        if ((element.active = true)) {
          dataActive = "Active";
        } else {
          dataActive = "Inactive";
        }
        this.dataBody.push({
          name: element.name,
          condition: this.condition,
          action: this.action,
          active: dataActive,
        });
        this.action = "";
        this.condition = "";
        dataActive = "";
      });

      console.log(this.dataBody);
      var doc = new jsPDF("p", "pt");
      doc.setFontSize(8).text("Alert Setting", 40, 40);
      var newDat = moment().format("MM/DD/YYYY hh:mm:ss");
      doc.setFontSize(7).text(505, 25, newDat);
      var values = this.dataBody.map((elemento) => Object.values(elemento));
      console.log(values);
      doc.autoTable({
        theme: "striped",
        headStyles: { fillColor: [50, 192, 64], textColor: [255, 255, 255] },
        styles: { fontSize: 7, theme: "plain" },
        head: [["AlertName", "Condition", "Action", "ActiveStatus"]],
        body: values,
        margin: { top: 50 },
      });
      doc.autoPrint();
      doc.output("dataurlnewwindow");
      this.dataBody = []; //Clear dataBody
    },
    exportPDF() {
      console.log(this.actionList);
      var datacondition = "";
      var dataAction = "";
      var dataActive = "";
      this.actionList.forEach((element) => {
        element.con.forEach((data) => {
          Object.keys(data).forEach((key) => {
            this.condition += data[key] + " ";
          });
          console.log(this.condition);
        });
        element.action.forEach((data) => {
          Object.keys(data).forEach((key) => {
            this.action += data[key] + " ";
          });
          console.log(this.action);
        });
        console.log(this.action);
        if ((element.active = true)) {
          dataActive = "Active";
        } else {
          dataActive = "Inactive";
        }
        this.dataBody.push({
          name: element.name,
          condition: this.condition,
          action: this.action,
          active: dataActive,
        });
        this.action = "";
        this.condition = "";
        dataActive = "";
      });

      console.log(this.dataBody);
      var doc = new jsPDF("p", "pt");
      doc.setFontSize(8).text("Alert Setting", 40, 40);
      var newDat = moment().format("MM/DD/YYYY hh:mm:ss");
      doc.setFontSize(7).text(505, 25, newDat);
      var values = this.dataBody.map((elemento) => Object.values(elemento));
      console.log(values);
      doc.autoTable({
        theme: "striped",
        headStyles: { fillColor: [50, 192, 64], textColor: [255, 255, 255] },
        styles: { fontSize: 7, theme: "plain" },
        head: [["AlertName", "Condition", "Action", "ActiveStatus"]],
        body: values,
        margin: { top: 50 },
      });
      doc.save("exportAlertList.pdf");
      this.dataBody = [];
    },
    onExport() {
      console.log(this.actionList);
      var datacondition = "";
      var dataAction = "";
      var dataActive = "";
      this.actionList.forEach((element) => {
        element.con.forEach((data) => {
          Object.keys(data).forEach((key) => {
            datacondition += data[key] + " ";
          });
        });
        element.action.forEach((data) => {
          Object.keys(data).forEach((key) => {
            dataAction += data[key] + " ";
          });
        });
        if ((element.active = true)) {
          dataActive = "Active";
        } else {
          dataActive = "Inactive";
        }
        this.dataExport.push({
          "alert name": element.name,
          condition: datacondition,
          action: dataAction,
          "active status": dataActive,
        });
        datacondition = "";
        dataAction = "";
        dataActive = "";
      });
      const dataWS = XLSX.utils.json_to_sheet(this.dataExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "exportAlert.xlsx");
      this.dataExport = [];
    },
    link() {
      this.$session.set("action", "create");
      this.$router.push({
        name: "CreateAction",
      });
    },
  },
  created() {
    this.userAccount = this.$session.get("username");
    this.$API.get("action/user").then((result) => {
      console.log(result.data)
      result.data.forEach((element) => {
        if (element.con) {
          element.con.forEach((con, i) => {
            element.con[i] = JSON.parse(con);
          });
        }
        if (element.action) {
          element.action.forEach((action, i) => {
            console.log(action)
            element.action[i] = JSON.parse(action);
          });
        }
      });
      this.actionList = result.data;
      console.log(this.actionList)
    });
  },
  mounted() {
    this.admin = this.$session.get("admin")
    switch (this.userAccount || this.admin) {
      case "betagrodemo":
        console.log("betagrodemo");
        var elem = document.getElementsByClassName("con-vs-card");
        Array.prototype.filter.call(elem, function (testElement) {
          testElement.style.background = "#212121";
        });
        var elemselect = document.getElementsByClassName("vs-card--content");
        Array.prototype.filter.call(elemselect, function (testElementselect) {
          // testElementselect.style.background = "#484848";
          testElementselect.style.color = "#ffffff";
        });
        var elemtable = document.getElementsByClassName("headerText");
        Array.prototype.filter.call(elemtable, function (testElementtable) {
          testElementtable.style.color = "#ffffff";
        });
        var elemtable2 = document.getElementsByClassName("vs__search");
        Array.prototype.filter.call(elemtable2, function (testElementtable2) {
          testElementtable2.style.background = "#ffffff";
        });
        var elemtable3 = document.getElementsByClassName("vs-button");
        Array.prototype.filter.call(elemtable3, function (testElementtable3) {
          testElementtable3.style.color = "#32c040";
        });
        document.getElementById("myDiv").style.paddingBottom = "1000px";
        break;
      default:
        console.log("Try looking up for a hint.");
    }
  },
};
</script>
<style scoped>
button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
  border-radius: 5px;
}
th .sort-th .th-sort-icon {
  color: white;
  padding: 0px;
}
#p {
  display: inline;
}
#v {
  display: none;
}
#center {
  display: flex;
  align-items: center;
}
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
@media screen and (max-width: 600px) {
  .a {
    /* background: pink; */
    width: 200px;
  }
  #v {
    display: inline;
  }
  #p {
    display: none;
  }
  .vuesax-app-is-ltr .vs-table--search-input {
    width: 100px;
    padding: o;
  }
  .vuesax-app-is-ltr .vs-table--search i {
    left: 15px;
  }
}
</style>